import { useEffect, useState } from 'react';

export default function useHasScrolledIntoView(
  elementRef: React.RefObject<HTMLElement>
) {
  const [hasScrolledIntoView, setHasScrolledIntoView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry) return;

      const elementLocationInView = entry.boundingClientRect.y;
      const isIntersecting = entry.isIntersecting;

      setHasScrolledIntoView(elementLocationInView < 0 || isIntersecting);
    });

    if (elementRef.current) observer.observe(elementRef.current);

    return () => observer.disconnect();
  }, [elementRef]);

  return hasScrolledIntoView;
}
